import { render, staticRenderFns } from "./Pse.vue?vue&type=template&id=1b8363e2"
import script from "./Pse.vue?vue&type=script&lang=js"
export * from "./Pse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports